// alterado - revisado

import React from 'react'

import LABEL from '../../../business-const/Label/Label'

import { FieldArray } from 'formik'

import {
    ValidatorFormPadrao,
} from '../../../business-components/Form/Form'

import {
    DivOverflowX,
} from '../../../business-components/Div/Div'

import {
    GridContainer,
    GridItem5xs10,
    GridItem12,
} from '../../../business-components/Grid/Grid'

import {
    CardGridEntradaDados,
    CardGridDivBody,
} from '../../../business-components/Card/Card'

import {
    TextFieldNumberSelect,
} from '../../../business-components/TextField/TextFieldSelect'

import {
    ButtonVisualizarGraficoMapaFinanceiro,
} from '../../../business-components/Button/Button'

import {
    CustomizedDialogsPopup,
} from '../../../business-components/Dialog/CustomizeDialogs'

import {
    CheckboxPadrao
} from '../../../business-components/Checkbox/Checkbox'

import {
    pesquisaList
} from '../../../business-rules/List/ListService'

import mapaFinanceiroGrupoList from '../../../business-rules/List/mapaFinanceiroGrupoList'

import mapaFinanceiroCabecalhoList from '../../../business-rules/List/mapaFinanceiroCabecalhoList'

import mapaFinanceiroItemList from '../../../business-rules/List/mapaFinanceiroItemList'

import mapaFinanceiroNotaList from '../../../business-rules/List/mapaFinanceiroNotaList'

import MapaFinanceiroFormGrafico from './MapaFinanceiroFormGrafico'

import {
    processaRegistrosDefaultIniciaisNotas
} from './MapaFinanceiroServiceNotas'



const MapaFinanceiroFormNotas = ({ values, handleChange, handleSubmit }) => {

    processaRegistrosDefaultIniciaisNotas(values)

    return (
        <ValidatorFormPadrao
            onSubmit={handleSubmit}
            onError={
                () => null
            }
        >
            <GridContainer>
                <GridItem12>
                    <CardGridEntradaDados>
                        <GridContainer
                            className='mt-3 justify-center'
                        >
                            <GridItem5xs10>
                                <CustomizedDialogsPopup
                                    maxWidth='lg'
                                    popupTitle={LABEL.graficoMapaFinanceiro}
                                    PopupButton={ButtonVisualizarGraficoMapaFinanceiro}
                                    popupComponent={
                                        <MapaFinanceiroFormGrafico
                                            values={values}
                                        />
                                    }
                                />
                            </GridItem5xs10>
                        </GridContainer>

                        <GridContainer
                            className='mt-3 justify-center'
                        >
                            <GridItem5xs10
                                align='center'
                            >
                                <CheckboxPadrao
                                    name="incluirMapaFinanceiroRelatorioCliente"
                                    label={LABEL.incluirMapaFinanceiroRelatorioCliente}
                                    checked={values.incluirMapaFinanceiroRelatorioCliente}
                                    onChange={handleChange}
                                />
                            </GridItem5xs10>
                        </GridContainer>

                        <CardGridDivBody>
                            <DivOverflowX>
                                <table
                                    border='0'
                                    cellPadding='0'
                                    cellSpacing='0'
                                    width='100%'
                                    style={{
                                        paddingTop: '20px',
                                        paddingRight: '20px',
                                        paddingLeft: '20px',
                                        //paddingBottom: '10px',
                                    }}
                                >
                                    <tbody>
                                        {mapaFinanceiroGrupoList?.map((grupo, indGrupo) => {
                                            return (
                                                <tr
                                                    key={indGrupo}
                                                >
                                                    <td
                                                        width='8%'
                                                    >
                                                        <table
                                                            border='0'
                                                            cellPadding='0'
                                                            cellSpacing='0'
                                                            width='100%'
                                                            style={{
                                                                padding: '5px',
                                                            }}
                                                        >
                                                            <tbody>
                                                                <tr>
                                                                    <td
                                                                        className='text-20 bg-light-dark'
                                                                        style={{
                                                                            padding: '5px',
                                                                        }}
                                                                    >
                                                                        {grupo.descricao}
                                                                    </td>
                                                                </tr>
                                                            </tbody>
                                                        </table>
                                                    </td>

                                                    <td
                                                        width='92%'
                                                    >
                                                        <table
                                                            border='0'
                                                            cellPadding='0'
                                                            cellSpacing='0'
                                                            width='100%'
                                                            style={{
                                                                padding: '5px',
                                                            }}
                                                        >
                                                            <tbody>
                                                                <tr>
                                                                    <td/>
                                                                    {mapaFinanceiroCabecalhoList?.map((cabecalho, indCabecalho) => {
                                                                        return (
                                                                            <td
                                                                                key={indCabecalho}
                                                                                className='font-bold'
                                                                                align="center"
                                                                                style={{
                                                                                    padding: '5px',
                                                                                }}
                                                                            >
                                                                                {cabecalho.descricao}
                                                                            </td>
                                                                        )
                                                                    })}
                                                                </tr>
                                                                <FieldArray name="mapaFinanceiro">
                                                                    {(arrayHelpers) => (
                                                                        values.mapaFinanceiro?.map((item, ind) => {

                                                                            const linhaMapaFinanceiroItem =
                                                                                pesquisaList(mapaFinanceiroItemList, 
                                                                                    item.id)

                                                                            return linhaMapaFinanceiroItem.grupo === grupo.id && (
                                                                                <tr
                                                                                    key={ind}
                                                                                    className='text-white font-light text-11'
                                                                                    bgcolor={grupo.bgColor}
                                                                                >
                                                                                    <td
                                                                                        className='text-15 font-medium'
                                                                                        width='18%'
                                                                                        style={{
                                                                                            border: '1px solid',
                                                                                            padding: '5px',
                                                                                        }}
                                                                                    >
                                                                                        {linhaMapaFinanceiroItem.descricao}
                                                                                    </td>
                                                                                    {linhaMapaFinanceiroItem.nota?.map((nota, indNota) => {
                                                                                        return (
                                                                                            <td
                                                                                                key={indNota}
                                                                                                width='15%'
                                                                                                style={{
                                                                                                    border: '1px solid',
                                                                                                    padding: '5px',
                                                                                                }}
                                                                                            >
                                                                                                {nota}
                                                                                            </td>
                                                                                        )
                                                                                    })}
                                                                                    <td
                                                                                        className='text-14'
                                                                                        width='7%'
                                                                                        style={{
                                                                                            border: '1px solid',
                                                                                            padding: '5px',
                                                                                        }}
                                                                                    >
                                                                                        <TextFieldNumberSelect
                                                                                            name={`mapaFinanceiro[${ind}].nota`}
                                                                                            placeholder={""}
                                                                                            value={item.nota === 0 ? 0 : item.nota || ''}
                                                                                            onChange={handleChange}
                                                                                            list={mapaFinanceiroNotaList}
                                                                                        />
                                                                                    </td>
                                                                                </tr>
                                                                            )
                                                                        })
                                                                    )}
                                                                </FieldArray>
                                                            </tbody>
                                                        </table>
                                                    </td>
                                                </tr>
                                            )
                                        })}
                                    </tbody>
                                </table>
                            </DivOverflowX>
                        </CardGridDivBody>

                        <GridContainer
                            className='mt-5 mb-3 justify-center'
                        >
                            <GridItem5xs10>
                                <CustomizedDialogsPopup
                                    maxWidth='lg'
                                    popupTitle={LABEL.graficoMapaFinanceiro}
                                    PopupButton={ButtonVisualizarGraficoMapaFinanceiro}
                                    popupComponent={
                                        <MapaFinanceiroFormGrafico
                                            values={values}
                                        />
                                    }
                                />
                            </GridItem5xs10>
                        </GridContainer>
                    </CardGridEntradaDados>
                </GridItem12>
            </GridContainer>
        </ValidatorFormPadrao>
    )
}

export default MapaFinanceiroFormNotas